import { render, staticRenderFns } from "./ReviewProfile.vue?vue&type=template&id=5ccdf601&"
import script from "./ReviewProfile.vue?vue&type=script&lang=js&"
export * from "./ReviewProfile.vue?vue&type=script&lang=js&"
import style0 from "./ReviewProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReviewProfile.vue"
export default component.exports